const formatText = function(message) {
    try {
        var codeBlockRegex = /~([^`]*)~/gm;
        var codeBlocks = [];
        var tempMessage = message.replace(codeBlockRegex, function(match, p1) {
            codeBlocks.push(p1); 
            return `___CODE_BLOCK___`;
        });

        var bold = /\*(?![0-9]+\*[0-9]+#)(\S(.*?\S)?)\*/gm;
        var breakLine = /\\n/gm;

        var html = tempMessage?.replace(bold, '<strong>$1</strong>');
        html = html?.replace(breakLine, '<br/>');

        html = html.replace(/___CODE_BLOCK___/gm, function() {
            return `<code>${codeBlocks.shift()}</code>`;
        });
        return html;
    } catch(e) {
        return message;
    }
}


const markuptext = (text,identifier,htmltag) =>
{
    var array = text.split(identifier);
    var previous = "";
    var previous_i;
    for (let i = 0; i < array.length; i++) {
        if (i % 2)
        {
            //odd number
        }
        else if (i!=0)
        {
            previous_i = eval(i-1);
            array[previous_i] = "<"+htmltag+">"+previous+"</"+htmltag+">";
        }
        previous = array[i];
    }
    var newtext = "";
    for (let i = 0; i < array.length; i++) {
        newtext += array[i];
    }
    return newtext;
};
const escape_HTML = function(html_str) {
    try{
        // 'use strict';
        
        html_str = html_str.replace(/<img[^>]*>/g,function(tag){
            tag = tag.replace(/<img/g,"#img");
            tag = tag.replace(/>/g,"#cimg");
            return tag;
        });

        var k = html_str.replace(/[&<>"]/g, function (tag) {
            var chars_to_replace = {
                '&': '&',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
            };
            return chars_to_replace[tag] || tag;
        });
        k = k.replace(/#img/g,"<img");
        k = k.replace(/#cimg/g,">");
        return k;
    }catch(e){
        // console.error(e)
        return html_str
    }
}


const linkify = function(inputText, filename, customFunction) {
    try {
        if (typeof filename === 'undefined') filename = false;

        // 1. Replace URLs starting with http://, https://, or ftp://
        const replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
        let replacedText = inputText?.replace(replacePattern1, function(data) {
            const filename = decodeURIComponent(data);
            if (String(data)?.includes("www.youtube.com/embed")) {
                return `<a href="#" class="custom-function-click">${filename ? filename : data}</a>`;
            } else {
                return `<a href="${data}" target="_blank">${filename ? filename : data}</a>`;
            }
        });

        // 2. Replace URLs starting with www. (without // before it)
        const replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
        replacedText = replacedText?.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

        // 3. Replace email addresses with mailto: links
        const replacePattern3 = /[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}/g;
        replacedText = replacedText?.replace(replacePattern3, function(data) {
            return `<a href="mailto:${data}">${data}</a>`;
        });

        // 4. Exclude text inside <a> tags before applying phone number pattern
        const excludeAnchorsPattern = /(<a\b[^>]*>.*?<\/a>)/gim;
        const parts = replacedText.split(excludeAnchorsPattern); // Split by anchor tags

        // 5. Apply phone number detection only to non-anchor parts
        const replacePattern4 = /\b(\+?\(?[0-9]{1,4}\)?[\s.-]?([0-9]{2,3}[\s.-]?){2,5}[0-9]{2,4})\b/g;
        for (let i = 0; i < parts.length; i++) {
            if (!parts[i].startsWith('<a')) { // Only replace in non-anchor parts
                parts[i] = parts[i].replace(replacePattern4, function(data) {
                    // Clean up the number for `tel:` link
                    const cleanNumber = data.replace(/[^\d+]/g, '');
                    return `<a href="tel:${cleanNumber}">${data}</a>`;
                });
            }
        }

        // 6. Join the parts back together
        replacedText = parts.join('');

        return replacedText;
    } catch (e) {
        // console.error(e, "text error 113");
    }
};



const extractName = (link) => {
    var replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?\=~_|!:,.;]*[-A-Z0-9+&@#\/%\=~_|])/gim;
    var linkInfo = {};
                var replacedText = link.replace(replacePattern1, function(data){
                        var filename = data.substring(data.lastIndexOf("/")+1);
                        filename = decodeURIComponent(filename);
        linkInfo.url = data;
        linkInfo.filename = filename;
                        return "";
                });
    return linkInfo;
};
const captiliseText = (text) => {
    const str = text.charAt(0).toUpperCase() + text.slice(1)
    return str
}

export {formatText, escape_HTML, markuptext, linkify, extractName, captiliseText}